import type { EntityConfig } from '../types'

export const reviewItemEntity: EntityConfig = {
  name: 'review-item',
  displayName: 'Review',
  pluralName: 'Reviews',
  status: {
    field: 'status',
    options: ['pending', 'in_progress', 'approved', 'rejected'],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'Pending', value: 'pending' },
      { label: 'In Progress', value: 'in_progress' },
      { label: 'Approved', value: 'approved' },
      { label: 'Rejected', value: 'rejected' },
    ],
    mappings: {
      all: ['pending', 'in_progress', 'approved', 'rejected'],
      pending: ['pending'],
      in_progress: ['in_progress'],
      approved: ['approved'],
      rejected: ['rejected'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    type: { field: 'type', type: 'select', label: 'Type' },
    priority: { field: 'priority', type: 'select', label: 'Priority' },
    network: { field: 'network', type: 'select', label: 'Network' },
  },
  uiFilterFields: ['status', 'type', 'priority', 'network'],
}
